import { OrderedMap } from 'immutable'
import { normalize, schema } from 'normalizr'
import { createReducer } from '@cheesecakelabs/boilerplate/utils'

import {
  GET_TOMORROW_ITEMS,
  SET_TOMORROW_ITEMS_ORDER,
  DELETE_TOMORROW_ITEM,
  CREATE_TOMORROW_ITEM,
  EDIT_TOMORROW_ITEM,
  CHECK_TOMORROW_ITEM,
} from './actions'

export const INITIAL_STATE = new OrderedMap()

export const tomorrowItemSchema = new schema.Entity('tomorrowItem', {}, { idAttribute: '_id' })

export const tomorrowItems = createReducer(INITIAL_STATE, {
  [GET_TOMORROW_ITEMS.FULFILLED]: (state, { payload }) =>
    new OrderedMap(normalize(payload, [tomorrowItemSchema]).entities.tomorrowItem),

  [SET_TOMORROW_ITEMS_ORDER.FULFILLED]: (state, { payload }) =>
    new OrderedMap(normalize(payload, [tomorrowItemSchema]).entities.tomorrowItem),

  [DELETE_TOMORROW_ITEM.FULFILLED]: (state, { payload }) =>
    new OrderedMap(normalize(payload, [tomorrowItemSchema]).entities.tomorrowItem),

  [CREATE_TOMORROW_ITEM.FULFILLED]: (state, { payload }) =>
    state.mergeDeep(normalize(payload, [tomorrowItemSchema]).entities.tomorrowItem),

  [EDIT_TOMORROW_ITEM.FULFILLED]: (state, { payload }) =>
    state.mergeDeep(normalize(payload, [tomorrowItemSchema]).entities.tomorrowItem),

  [CHECK_TOMORROW_ITEM.FULFILLED]: (state, { payload }) =>
    state.mergeDeep(normalize(payload, [tomorrowItemSchema]).entities.tomorrowItem),
})



// WEBPACK FOOTER //
// ./src/modules/tomorrow-items/reducers.js